import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Box, Icon, Tag } from "@nubeteck/components";
import {
  CardCalendarSubjectsStyled,
  ErrorTableMessage,
  SubjectButtonStyled,
  SubjectsContainerStyled,
  SubjectsListStyled,
  TabContainerStyled,
} from "./register-selection.styled";
import { type TabsProps, Button, Card, Modal, Skeleton } from "antd";
import {
  SubjectCalendarSchedule,
  SubjectDescriptionDisplay,
  SubjectTableSchedule,
} from "../../registration";
import ButtonSubject from "./button-subject";
import { ISection, ISelectedSubject, ISubject } from "src/Interfaces/subject";
import { horas } from "../../../constants";
import { useAppDispatch, useAppSelector } from "src/core/store";
import { setSubjectCodeForChange } from "src/core/store/slices/subjectSelectionSlice";
import useManageSubjects from "./hooks/useManageSubjects";
import NoSubjectsText from "./noSubjectsText";
import { FormatterUtils } from "@nubeteck/utils";
import { useGetGeneralSettingByIdMutation } from "../../../services/generalSettingsServices";
import { useGetCursosReprobadosMutation } from "../../../services/subjectsServices";
import { useEsEstudiantePatrocinadoMutation } from "../../../services/sponsorshipsServices";

// const SCREEN_NAME = "PantallaRegisterSelection";

const RegisterSelection = ({
  subjectsData,
  isLoading,
  updateSubjects,
  selectedData,
  registeredSubjects,
  periodId,
  setSufficiencyDrawerVisible,
}: {
  subjectsData: ISubject[];
  isLoading: boolean;
  updateSubjects: () => void;
  selectedData: any[];
  registeredSubjects: any[];
  periodId: number;
  setSufficiencyDrawerVisible: () => void;
}) => {
  const { setValue, getValues } = useFormContext();
  const dispatch: any = useAppDispatch();
  const { subjectCodeForChange } = useAppSelector((state: any) => state.subjectSelection);
  const [modal, contextHolder] = Modal.useModal();
  const [selectedSubject, setSelectedSubject] = React.useState<ISelectedSubject | undefined>();
  const [subjects, setSubjects] = React.useState<ISubject[]>([]);
  // const [hasError, setHasError] = useState<boolean>(false);
  // const [userEnrollementPage, setUserEnrollementPage] = useState<any>(null);
  // const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  // const [translatedData, setTranslatedData] = React.useState<{
  //   asignaturas: { [key: string]: string };
  // }>({
  //   asignaturas: {},
  // });
  const [mensajeAsignaturaReprobada, setMensajeAsignaturaReprobada] = useState<string>("");
  const [getGeneralSettingById] = useGetGeneralSettingByIdMutation();
  const [cursosReprobadosCodes, setCursosReprobadosCodes] = useState<string[]>([]);
  const [getCursosReprobados] = useGetCursosReprobadosMutation();
  const { userInfo } = useAppSelector((state: any) => state.user);
  const [tienePatrocinioAmazon, setTienePatrocinioAmazon] = useState<boolean>(false);
  const [esEstudiantePatrocinado] = useEsEstudiantePatrocinadoMutation();

  // Cargar mensaje de asignatura reprobada desde configuración general
  useEffect(() => {
    getGeneralSettingById("MensajeAsignaturaReprobada")
      .unwrap()
      .then((res: any) => {
        if (res?.responseStatus === "Success" && res?.data) {
          setMensajeAsignaturaReprobada(res.data);
        }
      })
      .catch(() => {
        // En caso de error, mantener el mensaje vacío
      });
  }, [getGeneralSettingById]);

  // Cargar lista de cursos reprobados del estudiante
  useEffect(() => {
    const carreraId = getValues()?.programa?.carreraId;
    const matricula = userInfo?.id;

    if (matricula && carreraId) {
      getCursosReprobados({ matricula, carreraId })
        .unwrap()
        .then((res: any) => {
          if (res?.responseStatus === "Success" && res?.data?.code) {
            setCursosReprobadosCodes(res.data.code);
          }
        })
        .catch(() => {
          setCursosReprobadosCodes([]);
        });
    }
  }, [getCursosReprobados, userInfo?.id, getValues]);

  // Verificar si el estudiante tiene patrocinio Amazon (IDs 1 y 2)
  useEffect(() => {
    const estudianteId = userInfo?.estudianteId;

    if (estudianteId) {
      // Verificar patrocinio Amazon Colones (ID 1) y Amazon Dolares (ID 2)
      Promise.all([
        esEstudiantePatrocinado({ patrocinioId: 1, estudianteId }).unwrap(),
        esEstudiantePatrocinado({ patrocinioId: 2, estudianteId }).unwrap(),
      ])
        .then(([resColones, resDolares]: any[]) => {
          // Manejar ambos formatos: respuesta directa (true/false) o con estructura { data: true/false }
          const tieneColones = resColones === true || resColones?.data === true;
          const tieneDolares = resDolares === true || resDolares?.data === true;
          setTienePatrocinioAmazon(tieneColones || tieneDolares);
        })
        .catch(() => {
          setTienePatrocinioAmazon(false);
        });
    }
  }, [esEstudiantePatrocinado, userInfo?.estudianteId]);

  // useEffect(() => {
  //   let cancel = false;
  //   setHasError(false);
  //   setIsLoadingContent(true);
  //   const timeoutId = setTimeout(() => {
  //     if (!cancel) {
  //       setUserEnrollementPage(null);
  //       setIsLoadingContent(false);
  //       setHasError(locale === 'en');
  //     }
  //   }, 3000);
  //   getUserEnrollementPage(locale)
  //     .then((res) => {
  //       const data = res?.data?.attributes || res?.data || res;
  //       if (!cancel) {
  //         clearTimeout(timeoutId);
  //         setUserEnrollementPage(data);
  //         setIsLoadingContent(false);
  //       }
  //     })
  //     .catch(() => {
  //       if (!cancel) {
  //         clearTimeout(timeoutId);
  //         setUserEnrollementPage(null);
  //         setIsLoadingContent(false);
  //         setHasError(locale === 'en');
  //       }
  //     });
  //   return () => {
  //     cancel = true;
  //     clearTimeout(timeoutId);
  //   };
  // }, [locale]);

  const esMatriculaAdministrativa = localStorage.getItem("matriculaAdministrativa") === "true";
  React.useEffect(() => {
    setSubjects(subjectsData);

    if (selectedSubject) {
      const subSelected = subjectsData?.find(
        (sub) => sub.asignaturaId == selectedSubject?.asignaturaId,
      );
      setSelectedSubject({
        ...selectedSubject,
        secciones: subSelected?.secciones?.map((sec: ISection) => ({
          ...sec,
          eventClass: subSelected?.eventClass,
          discipline: subSelected.discipline,
        })) as ISection[],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjectsData]);

  React.useEffect(() => {
    const subjectForChange = subjects?.find((sub) => sub.asignaturaCodigo === subjectCodeForChange);
    if (subjectForChange)
      setSelectedSubject({
        ...subjectForChange,
        seccionId: 0,
        horarios: [],
        secciones: subjectForChange.secciones as ISection[],
      });
  }, [subjectCodeForChange, subjects]);

  React.useEffect(() => {
    return () => {
      dispatch(setSubjectCodeForChange(""));
    };
  }, [dispatch]);

  const showElectivasMessage = () => {
    modal.info({
      title: "No es posible seleccionar esta electiva",
      icon: <Icon name="" color="#FFC53D" />,
      content: `Ya ha seleccionado una electiva de la misma disciplina.`,
      okText: "Aceptar",
      style: { top: 200 },
    });
  };

  const confirm = (newSection: ISection, actualSection: ISelectedSubject) => {
    if (actualSection?.estaInscrita) {
      modal.info({
        title: "No es posible matricular en este horario",
        icon: <Icon name="" color="#FFC53D" />,
        content: `Ya ha matriculado la asignatura ${actualSection?.asignaturaNombre}, que coincide con este horario.`,
        okText: "Aceptar",
        style: { top: 200 },
      });
    } else {
      modal.confirm({
        title: `¿Desea agregar la sección de ${selectedSubject?.asignaturaNombre} en este horario?`,
        icon: <Icon name="" color="#FFC53D" />,
        content: `La sección ${newSection.asignaturaSeccionCodigo} anteriormente escogida de ${actualSection.asignaturaNombre} será removida.`,
        okText: "Aceptar",
        onOk: () => {
          addSection(newSection);
        },
        cancelText: "Cancelar",
        style: { top: 200 },
      });
    }
  };

  const {
    getSlotsBySection,
    findScheduleCoincidence,
    removeSection,
    handleCollision,
    addSection,
    verifyCollision,
    getAvailableSlots,
    isLoadingSomething,
    selectedSections,
    verificarElectivasIguales,
  } = useManageSubjects(
    selectedData,
    registeredSubjects,
    subjects,
    selectedSubject,
    confirm,
    updateSubjects,
    periodId,
  );

  React.useEffect(() => {
    setValue("materiasSeleccionadas", selectedSections);
  }, [selectedSections, setValue]);

  const getSelectedSectionsAndCollisions = (startHour: { twentyFour: string; twelve: string }) => {
    const sectionsWithButtons = findScheduleCoincidence(startHour, selectedSections)?.map(
      ({ seccion, horarios }) => {
        const button = (
          <ButtonSubject
            randomColor={seccion.color}
            section={seccion.asignaturaNombre}
            type="selected"
            handleChange={
              selectedSections?.find((sect) => sect.seccionId === seccion.seccionId)
                ? () => {
                    removeSection(seccion);
                  }
                : verificarElectivasIguales(seccion)
                ? () => showElectivasMessage()
                : () => handleCollision(verifyCollision(seccion))
            }
          />
        );

        return { ...seccion, horarios, button };
      },
    );

    const sectionsToAdd = getSectionActiveByHour(startHour).filter(
      (sec) =>
        !sectionsWithButtons?.find(
          (s) =>
            s.seccionId === sec.seccionId &&
            s.horarios[0].diaId === sec.horarios[0].diaId &&
            s.horarios[0].horaInicio === sec.horarios[0].horaInicio &&
            s.horarios[0].horaFin === sec.horarios[0].horaFin,
        ),
    );

    const alreadyRegisteredSections = getAlreadyRegisteredSectionsByHour(startHour).filter(
      (sec) =>
        !sectionsWithButtons?.find(
          (s) =>
            s.seccionId === sec.seccionId &&
            s.horarios[0].diaId === sec.horarios[0].diaId &&
            s.horarios[0].horaInicio === sec.horarios[0].horaInicio &&
            s.horarios[0].horaFin === sec.horarios[0].horaFin,
        ),
    );

    return [...sectionsWithButtons, ...alreadyRegisteredSections, ...sectionsToAdd];
  };

  const getAlreadyRegisteredSectionsByHour = (startHour: {
    twentyFour: string;
    twelve: string;
  }) => {
    const sectionsWithButtons = findScheduleCoincidence(startHour, registeredSubjects ?? [])?.map(
      ({ seccion, horarios }) => {
        const button = (
          <ButtonSubject
            type="registered"
            randomColor="rgba(206, 161, 0, "
            section={seccion.asignaturaNombre}
            status="Inscrita"
            handleChange={() => null}
          />
        );

        return { ...seccion, horarios, button };
      },
    );
    return sectionsWithButtons;
  };

  const getSectionActiveByHour = (startHour: { twentyFour: string; twelve: string }) => {
    const sectionsWithButtons = findScheduleCoincidence(
      startHour,
      selectedSubject?.secciones ?? [],
    )?.map(({ seccion, horarios }) => {
      const collisionResult = verifyCollision(seccion);
      const isCollision = collisionResult.subjectCollision;

      const button = (
        <ButtonSubject
          type={isCollision ? "collision" : "avaliable"}
          randomColor="rgba(206, 161, 0, "
          section={`sección ${seccion.asignaturaSeccionCodigo}`}
          status={getSlotsBySection(seccion.seccionId)}
          handleChange={() => handleCollision(collisionResult)}
        />
      );

      return { ...seccion, horarios, button };
    });
    return sectionsWithButtons;
  };

  const getSesion = (monedaId: number) => {
    return monedaId === 2 ? "₡" : "$";
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Oferta`,
      children: (
        <SubjectTableSchedule
          isLoading={isLoadingSomething || isLoading}
          secciones={selectedSubject?.secciones?.map((sc) => {
            const cupo: string = sc.cupo;
            // const cupo: string = getSlotsBySection(sc.seccionId);
            const estaSeleccionada = selectedSections?.find(
              (sect) => sect.seccionId === sc.seccionId,
            );
            return {
              ...sc,
              cupo,
              seccionPrecio: `${getSesion(selectedSubject.monedaId ?? 2)} ${FormatterUtils.number(
                (sc.seccionPrecio as number)?.toFixed(2),
              )}`,
              acciones: (
                <Button
                  type="link"
                  disabled={
                    (cupo === "lleno" || cupo == "0" || cupo === "Indefinido") && !estaSeleccionada
                  }
                  onClick={
                    estaSeleccionada
                      ? () => {
                          removeSection(sc);
                        }
                      : verificarElectivasIguales(sc)
                      ? () => showElectivasMessage()
                      : () => {
                          handleCollision(verifyCollision(sc));
                        }
                  }
                >
                  {estaSeleccionada ? "Remover selección" : "Seleccionar"}
                  {verifyCollision(sc).subjectCollision !== undefined ? (
                    <ErrorTableMessage>Choque de horarios</ErrorTableMessage>
                  ) : null}
                </Button>
              ),
            };
          })}
        />
      ),
    },
    {
      key: "2",
      label: `Oferta en vista de calendario`,
      children: (
        <SubjectCalendarSchedule
          isLoading={isLoadingSomething || isLoading}
          secciones={horas.map((hr) => ({
            hora: hr.twelve,
            secciones: getSelectedSectionsAndCollisions(hr)
              .sort((a, b) => a.seccionId - b.seccionId)
              ?.map((sc) => ({
                ...sc,
                // cupo: getSlotsBySection(sc.seccionId),
              })),
          }))}
        />
      ),
    },
    {
      key: "3",
      label: `Descripción de la materia`,
      children: (
        <SubjectDescriptionDisplay
          descripcion={selectedSubject?.descripcion ?? ""}
          asignaturaNombre={
            selectedSubject?.asignaturaNombre ??
            "Selecciona una materia para ver su información y horario."
          }
          contenido={selectedSubject?.contenido ?? []}
          asignaturaCodigo={selectedSubject?.asignaturaCodigo ?? ""}
          asignaturaId={0}
        />
      ),
    },
  ];

  return (
    <Box style={{ position: "relative" }}>
      {subjects?.length == 0 ? (
        <>
          {esMatriculaAdministrativa && (
            <Button
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                zIndex: 20,
                borderColor: "#006aea",
                color: "#006aea",
              }}
              type="default"
              onClick={setSufficiencyDrawerVisible}
            >
              Agregar suficiencia
            </Button>
          )}
          <NoSubjectsText />
        </>
      ) : (
        <CardCalendarSubjectsStyled>
          <Box>
            <SubjectsListStyled>
              <SubjectsContainerStyled>
                {esMatriculaAdministrativa && (
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderColor: "#006aea",
                      color: "#006aea",
                    }}
                    type="default"
                    onClick={setSufficiencyDrawerVisible}
                  >
                    <Icon name="" />
                    Suficiencia
                  </Button>
                )}
                <Skeleton loading={isLoading} active round />
                <Skeleton loading={isLoading} active round />
                <Skeleton loading={isLoading} active round />
                {!isLoading &&
                  subjects?.map((subject) => (
                    <SubjectButtonStyled
                      key={subject.asignaturaCodigo}
                      style={{ alignItems: "start" }}
                      type="text"
                      onClick={() => {
                        getAvailableSlots(
                          subject.asignaturaId ?? 0,
                          getValues().programa.carreraId,
                        ).then(() => {
                          setSelectedSubject({
                            ...subject,
                            seccionId: 0,
                            horarios: [],
                            secciones: subject.secciones?.map((sec) => ({
                              ...sec,
                              eventClass: subject.eventClass,
                              discipline: subject.discipline,
                            })) as ISection[],
                          });
                        });
                      }}
                      className={
                        selectedSubject?.asignaturaCodigo === subject.asignaturaCodigo
                          ? "is-selected"
                          : ""
                      }
                    >
                      <span>
                        {subject.asignaturaCodigo} {subject.asignaturaNombre}
                      </span>
                      <Box>Créditos: {subject.creditos}</Box>
                      <Box>H.S: {subject.hs}</Box>
                      {subject.esSuficiencia && (
                        <span className="cost-container">
                          <Tag color="processing" bordered={false}>
                            Suficiencia
                          </Tag>
                        </span>
                      )}
                      <hr />
                    </SubjectButtonStyled>
                  ))}
              </SubjectsContainerStyled>
            </SubjectsListStyled>
            <Box>
              {selectedSubject?.asignaturaNombre !== selectedSubject?.descripcion ? (
                <Card style={{ border: "1px solid rgb(190, 30, 100)", marginTop: "20px" }}>
                  {selectedSubject?.descripcion}
                </Card>
              ) : null}
              {selectedSubject &&
                mensajeAsignaturaReprobada &&
                tienePatrocinioAmazon &&
                cursosReprobadosCodes.includes(selectedSubject.asignaturaCodigo ?? "") && (
                  <Card
                    style={{
                      border: "1px solid rgb(190, 30, 100)",
                      marginTop: "20px",
                      backgroundColor: "rgba(190, 30, 100, 0.05)",
                    }}
                  >
                    {mensajeAsignaturaReprobada}
                  </Card>
                )}
              <TabContainerStyled
                defaultActiveKey={subjectCodeForChange === "" ? "1" : "2"}
                items={items}
              />
            </Box>
          </Box>
        </CardCalendarSubjectsStyled>
      )}
      {contextHolder}
    </Box>
  );
};

export default RegisterSelection;
